const SERVICE_TAX_OPTIONS = ["Taxable", "Non Taxable"];
const SERVICE_TYPE_OPTIONS = ["Standard", "Group"];

const trimValue = (value) => String(value || "").trim();

export const createServiceInitialValues = (userId = "", defaultType = "Standard") => ({
  service_name: "",
  serviceType: defaultType === "Group" ? "Group" : "Standard",
  groupCategory: "",
  description: "",
  price: "",
  priority: "",
  user_id: userId,
  tax: "Taxable",
});

export const prepareServiceFormValues = (value = {}, userId = "", defaultType = "Standard") => ({
  ...createServiceInitialValues(userId, defaultType),
  ...value,
  service_name: value.service_name || "",
  serviceType: value.serviceType === "Group" ? "Group" : defaultType === "Group" ? "Group" : "Standard",
  groupCategory: value.groupCategory || "",
  description: value.description || "",
  price: value.price ?? "",
  priority:
    value.priority === "" || value.priority === null || typeof value.priority === "undefined"
      ? ""
      : value.priority,
  tax: value.tax || "Taxable",
  user_id: value.user_id || userId,
});

export const buildServicePayload = (value = {}, userId = "") => {
  const prepared = prepareServiceFormValues(value, userId);

  return {
    ...prepared,
    service_name: trimValue(prepared.service_name),
    serviceType: prepared.serviceType === "Group" ? "Group" : "Standard",
    groupCategory:
      prepared.serviceType === "Group" ? trimValue(prepared.groupCategory) : "",
    description: trimValue(prepared.description),
    price:
      prepared.price === "" || prepared.price === null || typeof prepared.price === "undefined"
        ? ""
        : String(prepared.price).trim(),
    priority:
      prepared.priority === "" || prepared.priority === null || typeof prepared.priority === "undefined"
        ? ""
        : Number(prepared.priority),
    tax: prepared.tax || "Taxable",
    user_id: prepared.user_id || userId,
  };
};

export const getServiceFormFields = (currentValues = {}) => {
  const isGroup = (currentValues?.serviceType || "Standard") === "Group";

  return [
    {
      name: "serviceType",
      label: "Service Type",
      type: "select",
      options: SERVICE_TYPE_OPTIONS.map((option) => ({
        value: option,
        label: option,
      })),
    },
    { name: "service_name", label: isGroup ? "Group Service Name" : "Service Name", type: "text" },
    ...(isGroup
      ? [{ name: "groupCategory", label: "Job Category", type: "text" }]
      : []),
    { name: "description", label: "Short Description", type: "text" },
    { name: "price", label: "Price ($)", type: "number" },
    {
      name: "priority",
      label: "Priority",
      type: "number",
      helperText: "Lower number appears higher in the list",
      inputProps: { min: 1, step: 1 },
      formatter: (rawValue) => {
        if (rawValue === "") return "";
        return rawValue;
      },
    },
    {
      name: "tax",
      label: "Tax Status",
      type: "select",
      options: SERVICE_TAX_OPTIONS.map((option) => ({
        value: option,
        label: option,
      })),
    },
  ];
};
